export default __webpack_public_path__ + "static/media/discordSS.532540a2.png";